import {
	find,
	findIndex,
	flatten,
	filter
} from "lodash";
import template from "./entity-contact-selector.html";
import "./entity-contact-selector.less";
import {
	EVENT_LOAD_OPTIONS,
	EVENT_VALUE_CHANGED,
	EVENT_CLEAR_VALUE,
	EVENT_SET_VALUE,
	EVENT_PAGE_LOADED,
	EVENT_REVERT_VALUES,
	EVENT_SET_FORM_PRISTINE,
	EVENT_TIMEZONE_SET
} from "constants.js";

import { findEntityRecursively } from "../../../../utils/entities/findEntityRecursively";

// entity-contact-selector
export class Controller {
	options = [];
	lookups = [];
	uiHelpers = null;
	fieldControllers = [];

	constructor($scope, eventBus, uiHelpers, featureHelper, $logger, $timeout) {
		this._scope = $scope;
		this.uiHelpers = uiHelpers;
		this.featureHelper = featureHelper;
		this.$logger = $logger;
		this.$timeout = $timeout;

		this.fieldControllers = [];
	}

	$onInit() {
		this._eventBus = this.reportScope.events;
		this.initialized = false;
		this._unregister = this.reportFormCtrl.registerFieldController(this);

		this.contactField = {
			...this.field,
			Name: this.field.ContactLabel || this.field.Name,
			placeHolder: "Please select a captain",
			isDisabled: true,
			Id: `${this.field.Id}-secondary`,
			rootFieldId: this.field.Id,
			Data: [],
			setEntityTimezone: false
		};

		this.entityField = {
			...this.field,
			Id: `${this.field.Id}-primary`,
			rootFieldId: this.field.Id
		};

		this._eventBus.register(EVENT_VALUE_CHANGED(this.entityField.Id), (e, params) => {
			if(!params.noSelfChange) {
				this.fullEntity = params.value;
				this.handleChange(params);
			}
		}, this._scope);

		this._eventBus.register(EVENT_VALUE_CHANGED(this.contactField.Id), () => {
			this._eventBus.trigger(EVENT_VALUE_CHANGED(this.field.Id), {
				field: this.field,
				value: this.buildResult(),
				noSelfChange: true,
				force: true,
				fullEntity: this.fullEntity
			});
		}, this._scope);

		this._eventBus.register(EVENT_TIMEZONE_SET(this.entityField.Id), (e, params) => {
			this._eventBus.trigger(EVENT_TIMEZONE_SET(this.field.Id), params);
		}, this._scope);

		this._eventBus.register(EVENT_CLEAR_VALUE(this.field.Id), () => {
			this.handleChange();
		}, this._scope);

		this._eventBus.register(EVENT_REVERT_VALUES, () => {
			this.revertValue();
		}, this._scope);

		this._eventBus.register(EVENT_SET_FORM_PRISTINE, () => {
			this.setPristine();
		}, this._scope);

		this._eventBus.register(EVENT_PAGE_LOADED, () => {
			if(this.forceInitValueChangeTrigger) {
				this._eventBus.trigger(EVENT_VALUE_CHANGED(this.field.Id), {
					field: this.field,
					value: this.buildResult(),
					noSelfChange: true,
					force: true,
					fullEntity: this.fullEntity
				});
			}
		}, this._scope);

		this.initialValue = find(this.values, v => v.FieldId === this.field.Id);

		if(this.values && this.initialValue) {
			this.contactValues = [{
				FieldId: this.contactField.Id,
				EntityId: this.initialValue?.ContactId
			}];

			this.entityValues = [{
				FieldId: this.entityField.Id,
				EntityId: this.initialValue?.EntityId
			}];

			this.contactField.isReadonly = this.field.isReadonly;
			this.entityField.isReadonly = this.field.isReadonly;
			this.contactField.placeHolder = null;
			this.contactField.Data = [];

			if(this.initialValue?.EntityId) {
				const match = findEntityRecursively(this.field.Data, this.initialValue.EntityId);

				if(match) {
					for(let depth = match.depth; depth >= 0; depth--) {
						const fullEntity = match[depth];

						if(fullEntity.Contacts?.length) {
							this.contactField.Data = fullEntity.Contacts;

							this.fullEntity = fullEntity;

							break;
						}
					}
				}
			}
		}

		this._scope.$watch(
			() => { return this.field.isDisabled; },
			(next, prev) => {
				if(next !== prev) {
					this.contactField.isDisabled = !!(next && this.values);
					this.entityField.isDisabled = !!next;
				}
			}
		);

		this._scope.$watch(
			() => { return this.field.isReadonly; },
			(next, prev) => {
				if(next !== prev) {
					this.contactField.isReadonly = !!(next && this.values);
					this.entityField.isReadonly = !!next;
				}
			}
		);

		this._scope.$watch(
			() => { return this.field.hasValidationError; },
			(next, prev) => {
				if(next !== prev) {
					this.contactField.hasValidationError = !!(next);
					this.entityField.hasValidationError = !!(next);
				}
			}
		);

		this._scope.$watch(
			() => { return this.field.hasValidationWarning; },
			(next, prev) => {
				if(next !== prev) {
					this.contactField.hasValidationWarning = !!(next);
					this.entityField.hasValidationWarning = !!(next);
				}
			}
		);
	}

	handleChange(selected) {
		if(selected && selected.value) {
			this.contactField.Data = selected.value.Contacts || [];

			if(!selected.field.isDisabled && !selected.field.isReadonly) {
				this.contactField.isDisabled = false;
			}


			let contactId;
			//if this field has report values, and it's not initialized
			if(!!this.values && !this.initialized) {
				//then get the contact id from the reports incoming contact id}
				contactId = find(this.values, (value) => value.FieldId === this.field.Id)?.ContactId;
			}
			else {
				const activeContacts = filter(selected?.value?.Contacts, contact => !!contact.IsActive);
				if(activeContacts?.length === 1)
					contactId = activeContacts[0].Id;
			}

			this._eventBus.trigger(EVENT_LOAD_OPTIONS(this.contactField.Id), {
				data: this.contactField.Data,
				suppressAutoselect: !!this.initialValue && !this.initialValue.ContactId ||
					(contactId && !find(this.contactField.Data, contact => contact.Id === contactId))
			});

			// the check is to make sure that the captain wasn't deleted
			if(contactId && find(selected.value.Contacts, contact => contact.Id === contactId)) {
				this._eventBus.trigger(EVENT_SET_VALUE(this.contactField.Id), { value: { Id: contactId } });
				this._eventBus.trigger(EVENT_VALUE_CHANGED(this.field.Id), {
					field: this.field,
					value: this.buildResult(),
					noSelfChange: true,
					force: true,
					isInitializing: selected.isInitializing
				});
			}

			this.initialized = true;
		}
		else {
			this.contactField.isDisabled = true;
			this._eventBus.trigger(EVENT_CLEAR_VALUE(this.contactField.Id));
			this._eventBus.trigger(EVENT_VALUE_CHANGED(this.field.Id), {
				field: this.field,
				value: this.buildResult(),
				noSelfChange: true,
				force: true
			});
		}

		const currentResult = this.getCurrentValue();
		const isDirty = (this.field.visible !== false || this.initialValue !== undefined) && currentResult[0].isDirty;
		this.setFieldDirty(this.field.Id, isDirty);
	}

	revertValue() {
	}

	setPristine() {
		this.initialValue = this.getCurrentValue(false)[0];
	}

	getCurrentValue = (isApiCall) => {
		const fullResult = this.buildResult(isApiCall);
		let result = undefined;

		if(fullResult !== undefined && fullResult.Entity !== undefined && fullResult.Contact !== undefined) {
			result = {
				FieldId: this.field.Id,
				EntityId: fullResult.Entity?.EntityId,
				ContactId: fullResult.Contact?.EntityId
			};
		}

		if(!isApiCall && this.field.IsNotReported !== true && this.field.IsHidden !== true) {
			if(!result) {
				result = { FieldId: this.field.Id };
				result.hasResultForRuleRun = false;
			}

			result.Classifications = fullResult?.Entity.Classifications;
			result.Identifiers = fullResult?.Entity.Identifiers;
			result._code = fullResult?.Entity._code;

			result.isDirty = (result.EntityId != (this.initialValue && this.initialValue.EntityId)
				|| result.ContactId != (this.initialValue && this.initialValue.ContactId));
		}

		return result ? [result] : [];
	}

	buildResult(isApiCall) {
		const vals = flatten(this.fieldControllers.map((x) => {
			const val = x.getCurrentValue(isApiCall);
			return val;
		}));

		const contactVal = find(vals, (field) => { return field.FieldId === this.contactField.Id; });
		const entityVal = find(vals, (field) => { return field.FieldId === this.entityField.Id; });

		const result = entityVal || contactVal ? {
			FieldId: this.field.Id,
			Entity: entityVal,
			Contact: contactVal
		} : undefined;

		return result;
	}

	$onDestroy() {
		this._unregister();
	}

	dirtyInterceptor = (fieldId, isDirty) => {
		if(this.field.visible === true) {
			this.setFieldDirty(this.field.Id, isDirty);
		}
	}

	registerFieldController = (fieldController) => {
		this.fieldControllers.push(fieldController);
		return function unregister() {
			const idx = findIndex(this.fieldControllers, x => x === fieldController);
			if(idx !== -1) {
				this.fieldControllers.splice(idx, 1);
			}
		};
	}
}

export default angular
	.module("vesl.components.report-form.entity-contact-selector", [])
	.component("entityContactSelector", {
		template,
		controller: Controller,
		bindings: {
			field: "<",
			values: "<",
			setFieldDirty: "="
		},
		require: {
			reportFormCtrl: "^reportForm",
			reportScope: "^^reportScope"
		}
	}).name;
